import { useQuery, UseQueryOptions } from 'react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(endpoint: string, requestInit: RequestInit, query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(endpoint, {
      method: 'POST',
      ...requestInit,
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type FilterInput = {
  type?: InputMaybe<TypeFilter>;
};

export type Query = {
  __typename?: 'Query';
  listTechnicalSkills?: Maybe<Result>;
};


export type QueryListTechnicalSkillsArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type Result = {
  __typename?: 'Result';
  items: Array<TechnicalSkill>;
};

export enum SkillArea {
  Backend = 'BACKEND',
  Frontend = 'FRONTEND',
  Mobile = 'MOBILE',
  Other = 'OTHER'
}

export enum SkillFrequency {
  Frequently = 'FREQUENTLY',
  Occasionally = 'OCCASIONALLY',
  Rarely = 'RARELY',
  Unlikely = 'UNLIKELY'
}

export enum SkillType {
  Main = 'MAIN',
  Secondary = 'SECONDARY'
}

export type TechnicalSkill = {
  __typename?: 'TechnicalSkill';
  active: Scalars['Boolean'];
  area: SkillArea;
  frequency?: Maybe<SkillFrequency>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<SkillType>;
};

export type TypeFilter = {
  eq?: InputMaybe<SkillType>;
};

export type ListSkillsQueryVariables = Exact<{
  type?: InputMaybe<SkillType>;
}>;


export type ListSkillsQuery = { __typename?: 'Query', listTechnicalSkills?: { __typename?: 'Result', items: Array<{ __typename?: 'TechnicalSkill', id: string, name: string, type?: SkillType | null | undefined, area: SkillArea, active: boolean }> } | null | undefined };


export const ListSkillsDocument = `
    query listSkills($type: SkillType) {
  listTechnicalSkills(filter: {type: {eq: $type}}) {
    items {
      id
      name
      type
      area
      active
    }
  }
}
    `;
export const useListSkillsQuery = <
      TData = ListSkillsQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: ListSkillsQueryVariables,
      options?: UseQueryOptions<ListSkillsQuery, TError, TData>
    ) =>
    useQuery<ListSkillsQuery, TError, TData>(
      variables === undefined ? ['listSkills'] : ['listSkills', variables],
      fetcher<ListSkillsQuery, ListSkillsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, ListSkillsDocument, variables),
      options
    );